import React from "react";
import Container from "react-bootstrap/Container";
import MobileIosImg from "../potfolio/mobile-ios.png";
import PerkopolisShopImg from "../potfolio/perkopolis_shop.png";
import FoodpackagesImg from "../potfolio/foodpackagesImg.jpg";

const roles = [
  {
    company: "Perkopolis", date: "March 2024 – June 2026", context: "Toronto",
    stack: "Flutter · Firebase · NetSuite SuiteCommerce Advanced · SuiteScript · Klaviyo",
    points: [
      "Independently developed, tested, deployed, and maintained the Flutter iOS/Android application, including the Apple App Store and Google Play release lifecycle.",
      "Integrated Firebase analytics and push notifications, plus Klaviyo audience-targeted notifications.",
      "Developed SuiteCommerce landing, product, and registration pages with HTML, CSS, and JavaScript; built NetSuite CRM lead-generation flows, SuiteScript backend work, and API integrations."
    ]
  },
  {
    company: "Uniwell Technologies Inc", date: "March 2021 – March 2024", context: "Commercial client projects",
    stack: "React · JavaScript · TypeScript · Node.js · Express · MongoDB · SQL",
    points: [
      "Contributed to multiple commercial client projects, including emery.school, building UI pages and components, APIs, backend features, database changes, and integrations.",
      "Resolved bugs and collaborated with designers, QA, frontend, and backend developers through Git, pull requests, code reviews, Jira, and Agile sprints."
    ]
  },
  {
    company: "Food Link Delivery Ltd", date: "January 2021 – March 2021", context: "Short contract · Sole developer",
    stack: "React · Node.js · Express · MongoDB · Heroku",
    points: [
      "Built foodpackages.ca from scratch as the sole developer, covering the frontend, backend/API, database, order flow, admin page, and production deployment on Heroku."
    ]
  }
];

export default function Experience() {
  return (
    <section className="recruiter-section" id="experience" aria-labelledby="experience-title">
      <Container>
        <p className="recruiter-eyebrow">Professional experience</p>
        <h2 id="experience-title">Production work, from UI to release.</h2>
        <div className="recruiter-roles">
          {roles.map((role, index) => (
            <article key={role.company} className="recruiter-role">
              <div className="recruiter-role-heading">
                <div><h3>{role.company}</h3><p>Full Stack Developer</p></div>
                <div><p>{role.date}</p><p>{role.context}</p></div>
              </div>
              <ul className="recruiter-list">{role.points.map(point => <li key={point}>{point}</li>)}</ul>
              <p className="recruiter-tech">{role.stack}</p>
              {index === 0 && <details>
                <summary>View Perkopolis production work</summary>
                <div className="recruiter-work-media">
                  <figure><img src={MobileIosImg} alt="Perkopolis Flutter app product page on iOS" loading="lazy" /><figcaption>Flutter mobile application</figcaption></figure>
                  <figure><img src={PerkopolisShopImg} alt="Perkopolis SuiteCommerce shop" loading="lazy" /><figcaption>SuiteCommerce web development</figcaption></figure>
                </div>
                <div className="recruiter-actions">
                  <a href="https://www.perkopolis.com/">Perkopolis website</a>
                  <a href="https://apps.apple.com/uy/app/perkopolis-mobile/id6458834344">Perkopolis App Store</a>
                  <a href="https://play.google.com/store/apps/details?id=com.perkopolis.perkopolis_mobile">Perkopolis Google Play</a>
                </div>
                <figure className="recruiter-video"><video controls playsInline preload="none" aria-label="Perkopolis API booking interface demonstration" src={`${process.env.PUBLIC_URL || ""}/media/api-booking-perkopolis.mp4`} /><figcaption>Silent demonstration of the API booking interface.</figcaption></figure>
              </details>}
              {index === 2 && <details><summary>View foodpackages.ca project screenshot</summary><img className="recruiter-food-image" src={FoodpackagesImg} alt="Food Link Delivery ordering website" loading="lazy" /></details>}
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
